// gets the CSRF token from the containing dom element
export function getCSRFToken() {
  const token = document.getElementsByTagName("meta")["csrf-token"];
  if (token) {
    return document.getElementsByTagName("meta")["csrf-token"].content;
  }

  return null;
}
